import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Form,
  Input,
  Row,
  Select,
  Modal,
  DatePicker,
  message,
  Tooltip,
  Button,
  Dropdown,
} from "antd";
import PatientService from "../../Services/PatientService";
import AuthService from "../../Services/AuthService";
import dayjs from "dayjs";
import moment from "moment";
import { CameraOutlined, FileOutlined, PlusOutlined } from "@ant-design/icons";
import profile from "../../assets/images/profile.png";
import Layout from "../../Layout";
import { FaSearch } from "react-icons/fa";
import CommonService from "../../Services/CommonService";
import { FaRegEdit } from "react-icons/fa";
import { GrValidate } from "react-icons/gr";
import { TiTick } from "react-icons/ti";
import MobNumVerification from "./MobNumVerification";
import AuthenticationService from "../../Services/AuthenticationService";
import { useSelector, useDispatch } from "react-redux";
import { getDataFromLocal } from "../../Redux/actions/AuthActions";

const gender = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];
const salutation = [
  { name: "Mr.", value: "Mr." },
  { name: "Mrs.", value: "Mrs." },
  { name: "Dr.", value: "Dr." },
  { name: "Ms.", value: "Ms." },
];
const bloodGroup = [
  { name: "A+", value: "A+" },
  { name: "A-", value: "A-" },
  { name: "B+", value: "B+" },
  { name: "B-", value: "B-" },
  { name: "AB+", value: "AB+" },
  { name: "AB-", value: "AB-" },
  { name: "O+", value: "O+" },
  { name: "O-", value: "O-" },
];
const marital = [
  { label: "Married", value: "M" },
  { label: "Unmarried", value: "U" },
  { label: "Seperated", value: "S" },
  { label: "Divorced", value: "D" },
  { label: "Widowed", value: "W" },
];

const Relation = [
  { name: "Father", value: "Father" },
  { name: "Mother", value: "Mother" },
  { name: "Daughter", value: "Daughter" },
  { name: "Son", value: "Son" },
  { name: "Brohter", value: "Brother" },
  { name: "Sister", value: "Sister" },
  { name: "Spouse", value: "Spouse" },
  { name: "Grandparent", value: "Grandparent" },
  { name: "Relative", value: "Relative" },
  { name: "Staff", value: "Staff" },
  { name: "Others", value: "Others" },
];

const MyProfile = () => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [patientData, setPatientData] = useState([]);
  const [patientFamilyData, setPatientFamilyData] = useState([]);
  const activePatient = JSON.parse(localStorage.getItem("patientData"));
  const LoginPatient = JSON.parse(localStorage.getItem("patientData"));
  const patientCode = activePatient?.patientId;
  const fileInputRef = useRef(null);
  const [photoValue, setPhotoValue] = useState(null);
  const [profileImage, setProfileImage] = useState();
  const [profileType, setProfileType] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [stateData, setStateData] = useState([]);
  const [genderValue, setGenderValue] = useState();
  const [bloodValue, setBloodValue] = useState();
  const [maritalStatus, setMaritalStatus] = useState();
  const [salutationValue, setSalutationValue] = useState();
  const [familyMemModal, setFamilyMemModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [relationList, setRelationList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [mobOtpModal, setMobOtpModal] = useState(false);
  const [mobEdit, setMobEdit] = useState(false);
  const [updatingMob, setUpdatingMob] = useState("");
  const [countries, setCountries] = useState([]);
  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const patientDataRedux = useSelector((state) => state.auth.patientData);
  const dispatch = useDispatch();
  const { TextArea } = Input;
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    PatientDetail();
    StateList();
    getCountriesList();
    getRelationsList();
    // PatientFamilyDetail();
  }, [patientCode]);

  const PatientDetail = async () => {
    try {
      const payload = { patientId: patientCode };
      const result = await PatientService.getPatient(payload);

      if (result.data) {
        const fetchedData = result.data || [];
        setPatientData(fetchedData);
        setProfileImage(
          process.env.REACT_APP_IMAGE_URL + fetchedData[0]?.photoName,
        );

        if (
          fetchedData[0] &&
          (fetchedData[0]?.dob || fetchedData[0]?.patientId)
        ) {
          if (fetchedData[0]?.dob) {
            let inputDob = fetchedData[0]?.dob;
            if (typeof inputDob === "number") {
              const dobString = inputDob.toString();
              const year = dobString.slice(0, 4);
              const month = dobString.slice(4, 6);
              const day = dobString.slice(6, 8);
              inputDob = `${month}/${day}/${year}`;
            }
            const formattedDob = dayjs(inputDob, "MM/DD/YYYY");
            if (formattedDob.isValid()) {
              const updatedPatientData = [...fetchedData];
              updatedPatientData[0].dob = formattedDob.format("MM/DD/YYYY");
              updatedPatientData[0].dob = formattedDob;
              setPatientData(updatedPatientData);
              setProfileImage(
                process.env.REACT_APP_IMAGE_URL +
                  updatedPatientData[0]?.photoName,
              );
              form.setFieldsValue(updatedPatientData[0]);
            } else {
              console.error("Invalid date format:", fetchedData[0]?.dob);
            }
          } else {
            form.setFieldsValue(fetchedData[0]);
          }
        } else {
          console.error("No patient data or invalid patient ID");
        }
      }
    } catch (error) {
      console.error("Error fetching patient details:", error);
      form.resetFields();
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // PatientFamilyDetail();
  };

  const getRelationsList = async () => {
    const payload = { status: 1 };
    try {
      const response = await CommonService.RelationList(payload);
      setRelationList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validImageTypes.includes(file.type)) {
        message.error("Only image files (JPG, PNG, JPEG) are allowed!");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        let imageArray = reader.result.split(",");
        setProfileImage(reader.result);
        setPhotoValue(imageArray[1]);
        setProfileType(file.type.split("/")[1]);
      };
      reader.readAsDataURL(file);
    }
  };

  const openCamera = async () => {
    setIsCameraOpen(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
      message.error("Please allow camera access in your browser settings.");
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop()); // Stop each track
      videoRef.current.srcObject = null; // Clear video source
    }
    setIsCameraOpen(false);
  };

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataUrl = canvas.toDataURL("image/png");

    setProfileImage(imageDataUrl);
    setPhotoValue(imageDataUrl.split(",")[1]);
    setProfileType("png");

    stopCamera(); // Stop camera after capturing photo
  };

  const uploadOptions = [
    {
      key: "1",
      label: (
        <Button
          className="text-white bg-[#189FAA]"
          type="text"
          icon={<FileOutlined />}
          onClick={handleClick}
        >
          Choose File
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          className="text-white bg-[#189FAA]"
          type="text"
          icon={<CameraOutlined />}
          onClick={openCamera}
        >
          Take Picture
        </Button>
      ),
    },
  ];

  const handleSelParPat = (data) => {
    form.setFieldsValue({ parentname: data.firstName });
    setSelectedPatient(data);
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const StateList = async () => {
    try {
      const result = await AuthService.stateMaster();
      if (result.data.message === "Record Not Found") {
        setStateData([]);
      } else {
        setStateData(result.data || []);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
      setStateData([]);
    }
  };

  const getCountriesList = async () => {
    let payload = {
      status: 1,
    };
    const response = await CommonService.CountriesList(payload);
    setCountries(response.data);
  };

  const handleEdit = () => {
    setIsEditing(true);
    setMobEdit(false);
  };
  const onGenderChange = (values) => {
    setGenderValue(values);
  };

  const handleSalutation = (values) => {
    setSalutationValue(values);
  };
  const handleBloodGroup = (values) => {
    setBloodValue(values);
  };
  const handleMerital = (values) => {
    setMaritalStatus(values);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setMobEdit(true);
  };

  const onFinish = () => {
    let values = form.getFieldValue();
    setLoader(true);
    const mandatoryFields = [
      "salutation",
      "firstName",
      "lastName",
      "dob",
      "gender",
      "bloodGroup",
      "maritalStatus",
      "mobile",
      "address1",
      "city",
      "state",
      "country",
      "pinCode",
    ];

    const emptyFields = mandatoryFields.filter((field) => !values[field]);

    if (emptyFields.length > 0) {
      message.error("Please fill in all mandatory fields");
      setLoader(false);
      return;
    }
    if (values.parentname && !values.relation) {
      message.error("Please select relation.");
      setLoader(false);
      return;
    }

    if (values.email && !validateEmail(values.email)) {
      message.error("Please enter a valid email.");
      setLoader(false);
      return;
    }

    if (
      values.emergencyContact &&
      !validatePhoneNumber(values.emergencyContact)
    ) {
      message.error(
        "Please enter 10 digit mobile number in emergency contact.",
      );
      setLoader(false);
      return;
    }

    if (values.pinCode && !validatePincode(values.pinCode)) {
      message.error("Please enter a valid pincode.");
      setLoader(false);
      return;
    }

    const relationDesc = relationList?.find(
      (rel) => rel.relationCode === values.relation,
    )?.relationDescription;
    let payload = {
      ...patientData[0],
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      country: values.country,
      state: values.state,
      createdBy: patientData[0]?.createdBy,
      dob: values.dob ? dayjs(values.dob).format("MM/DD/YYYY") : "",
      email: values.email ? values.email : patientData[0]?.email,
      bloodGroup: values.bloodGroup,
      salutation: values.salutation,
      firstName: values.firstName,
      lastName: values.lastName,
      parentPatientId: selectedPatient ? selectedPatient?.patientId : "",
      parentPatientName: selectedPatient ? selectedPatient?.firstName : "",
      relationCode: values.relation,
      relationDescription: selectedPatient ? relationDesc : "",
      patientId: patientCode,
      gender: values.gender,
      id: patientData[0]?.id,
      modifiedBy: patientCode,
      maritalStatus: values.maritalStatus,
      mobile: values.mobile,
      loginIdAvailableYN: patientData[0].loginIdAvailableYN,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      photo: photoValue,
      photoName: patientData[0]?.photoName,
      photoType: profileType,
      pinCode: values.pinCode,
      status: 1,
      account_Id: patientDataRedux?.account_Id,
      clinic_Id: patientDataRedux?.clinic_Id,
      insurance: values.insurance,
      emergencyContact: values.emergencyContact,
    };

    

    PatientService.patientUpdate(payload)
      .then((result) => {
        PatientDetail();
        dispatch(getDataFromLocal());
        message.success("Updated Successfully", 4);
        setLoader(false);
        setIsEditing(!isEditing);
      })
      .catch((error) => {
        message.error(error?.response?.data?.message);
        setLoader(false);
      });
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhoneNumber = (number) => /^\d{10}$/.test(number);

  const validatePincode = (pin) => /^\d{5,6}$/.test(pin);

  const handleMobValidate = async () => {
    setLoader(true);
    const mobNum = form.getFieldValue("mobile");

    if (!validatePhoneNumber(mobNum)) {
      message.error("Please enter your 10 digit mobile number");
      setLoader(false);
      return;
    }

    setUpdatingMob(mobNum);

    const payload = {
      patientId: patientCode,
      mobileNumber: mobNum,
      status: 1,
    };

    try {
      const response =
        await AuthenticationService.patientMobNumChangeOtp(payload);
      setLoader(false);
      if (response.data === 1) {
        setMobOtpModal(!mobOtpModal);
      }
    } catch (e) {
      console.error(e);
      message.error("Something went wrong. Please try again later.");
      setLoader(false);
    }
  };

  const handleMobModalClose = () => {
    setMobOtpModal(!mobOtpModal);
    setIsEditing(!isEditing);
    setMobEdit(!mobEdit);
  };

  const handleMobModalCancel = () => {
    setMobOtpModal(!mobOtpModal);
  };

  const handleMobEditEnable = () => {
    setIsEditing(false);
    setMobEdit(!mobEdit);
  };

  return (
    <Layout>
      <div className="p-5">
        <div className="flex justify-between">
          <h2 className="font-bold text-lg">My Profile</h2>
          {/* <div className="flex gap-2">
            <Button
              className=" h-9 px-2 flex justify-center text-white items-center gap-2 custom_filter"
              onClick={showModal}
            >
              + Add Family Member
            </Button>
          </div> */}
        </div>
        <div className="mt-6 border p-3 rounded w-full overflow-x-hidden">
          <div className="flex justify-end">
            <button
              className="w-20 border rounded-md bg-[#189FAA] font-medium h-9 px-2 flex justify-center text-white items-center gap-2 hover:text-white"
              onClick={handleEdit}
            >
              Edit
            </button>
          </div>

          <Form
            form={form}
            layout="vertical"
            className="grid grid-cols-5 sm:grid-cols-1  gap-3 w-full"
            autoComplete="off"
          >
            <>
              <div className="grid place-items-center">
                <Dropdown
                  menu={{ items: uploadOptions }}
                  trigger={["click"]}
                  disabled={!isEditing}
                >
                  <div className="Upload h-24 w-24 border-1 p-4 rounded-full cursor-pointer relative">
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      ref={fileInputRef}
                      disabled={!isEditing}
                    />
                    <div
                      // onClick={handleClick}
                      className="absolute bottom-0 right-0 rounded-full text-center p-1 bg-slate-300 cursor-pointer"
                      style={{ width: "24px", height: "24px", zIndex: 1 }}
                    >
                      <PlusOutlined style={{}} />
                    </div>

                    {profileImage ? (
                      <img
                        src={profileImage}
                        className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                      />
                    ) : (
                      <img
                        src={profile}
                        className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                      />
                    )}
                  </div>
                </Dropdown>
                <label htmlFor="" className="mt-2">
                  Upload Profile
                </label>
              </div>
              {isCameraOpen && (
                <div className="camera-container">
                  <video ref={videoRef} autoPlay className="w-full h-48" />
                  <canvas
                    ref={canvasRef}
                    width="200"
                    height="200"
                    style={{ display: "none" }}
                  />
                  <div className="flex justify-between">
                    <Button
                      type="primary"
                      onClick={capturePhoto}
                      className="mt-2"
                    >
                      Capture
                    </Button>
                    <Button
                      type="default"
                      onClick={stopCamera}
                      className="mt-2 text-white bg-[#189FAA]"
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}
            </>
            <>
              <Form.Item
                name="salutation"
                label={
                  <span>
                    Salutation <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <Select
                  className="h-10"
                  placeholder="Select"
                  style={{
                    width: "100%",
                  }}
                  value={salutationValue}
                  onChange={handleSalutation}
                  options={salutation.map((ele) => ({
                    value: ele.value,
                    label: ele.name,
                  }))}
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                name="firstName"
                label={
                  <span>
                    First Name <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <Input
                  placeholder="Enter"
                  className="h-10"
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                name="lastName"
                label={
                  <span>
                    LastName <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <Input
                  placeholder="Enter"
                  className="h-10"
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                name="dob"
                label={
                  <span>
                    DOB <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  className="w-full h-10"
                  disabled={!isEditing}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </Form.Item>
            </>
            <>
              <Form.Item name="patientId" label={<span>Patient ID</span>}>
                <Input placeholder="Enter" className="h-10" disabled={true} />
              </Form.Item>
            </>
            <>
              <Form.Item name="email" label={<span>E-mail</span>}>
                <Input
                  placeholder="Enter"
                  className="h-10"
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                label={
                  <span>
                    Gender <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="gender"
              >
                <Select
                  className="h-10"
                  placeholder="Select"
                  style={{
                    width: "100%",
                  }}
                  value={genderValue}
                  onChange={onGenderChange}
                  options={gender.map((ele) => ({
                    value: ele.value,
                    label: ele.label,
                  }))}
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                label={
                  <span>
                    Blood Group <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="bloodGroup"
              >
                <Select
                  className="h-10"
                  placeholder="Select"
                  style={{
                    width: "100%",
                  }}
                  value={bloodValue}
                  onChange={handleBloodGroup}
                  options={bloodGroup.map((ele) => ({
                    value: ele.value,
                    label: ele.name,
                  }))}
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                label={
                  <span>
                    Marital Status <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="maritalStatus"
              >
                <Select
                  className="h-10"
                  placeholder="Select"
                  style={{
                    width: "100%",
                  }}
                  value={maritalStatus}
                  onChange={handleMerital}
                  options={marital.map((ele) => ({
                    value: ele.value,
                    label: ele.label,
                  }))}
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <div className="relative">
              <Form.Item
                name="mobile"
                label={
                  <p className="flex items-center gap-1">
                    <span>Mobile</span>
                    <button
                      disabled={!isEditing || mobEdit}
                      className="disabled:cursor-not-allowed disabled:opacity-50"
                      onClick={handleMobEditEnable}
                    >
                      <FaRegEdit className="text-successColor" />
                    </button>
                  </p>
                }
              >
                <Input
                  placeholder="Enter"
                  className="h-10"
                  maxLength={10}
                  disabled={!mobEdit}
                />
              </Form.Item>
              {mobEdit && (
                <div className="absolute bottom-4 right-0">
                  <button
                    disabled={loader}
                    onClick={handleMobValidate}
                    className="text-iconBlue rounded-lg italic text-xs font-medium disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Verify
                  </button>
                </div>
              )}
            </div>

            {LoginPatient?.parentPatientId && (
              <>
                <Form.Item name="relationCode" label={<span>Relation</span>}>
                  <Select className="h-10" disabled={!isEditing}>
                    {relationList?.map((relation) => (
                      <Select.Option value={relation.relationCode}>
                        {relation.relationDescription}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            )}

            <>
              <Form.Item name="insurance" label={<span>Insurance</span>}>
                <Input
                  placeholder="Enter"
                  className="h-10"
                  disabled={!isEditing}
                />
              </Form.Item>
            </>

            <>
              <Form.Item
                name="emergencyContact"
                label={<span>Emergency Contact</span>}
              >
                <Input
                  placeholder="Enter"
                  className="h-10"
                  maxLength={10}
                  disabled={!isEditing}
                />
              </Form.Item>
            </>

            <>
              <Form.Item
                name="address1"
                label={
                  <span>
                    Address 1 <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <TextArea
                  style={{
                    resize: "none",
                  }}
                  rows={2}
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item name="address2" label={<span>Address 2</span>}>
                <TextArea
                  style={{
                    resize: "none",
                  }}
                  rows={2}
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                name="city"
                label={
                  <span>
                    City <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <Input
                  placeholder="Enter"
                  className="h-10"
                  disabled={!isEditing}
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                name="state"
                label={
                  <span>
                    State <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <Select
                  showSearch
                  className="h-10"
                  options={stateData.map((ele) => ({
                    value: ele.stateId,
                    label: ele.stateName,
                  }))}
                  disabled={!isEditing}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              </Form.Item>
            </>
            <>
              <Form.Item
                name="country"
                label={
                  <span>
                    Country <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                {/* <Input
                  placeholder="Enter"
                  className="h-10"
                  value="India"
                  disabled={!isEditing}
                /> */}
                <Select
                  disabled={!isEditing}
                  allowClear
                  className="h-10"
                  placeholder="Select Country"
                >
                  {countries?.map((country) => (
                    <Select.Option value={country.country_Id}>
                      {country.country_Name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </>
            <>
              <Form.Item
                name="pinCode"
                label={
                  <span>
                    Pincode <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
              >
                <Input
                  placeholder="Enter"
                  className="h-10"
                  disabled={!isEditing}
                  maxLength={6}
                  onKeyDown={(event) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                    ];
                    if (
                      !/[0-9]/.test(event.key) &&
                      !allowedKeys.includes(event.key)
                    ) {
                      event.preventDefault(); // Prevent non-numeric and non-control key input
                    }
                  }}
                />
              </Form.Item>
            </>
            {/* <div className="w-full flex items-center gap-2">
              <Form.Item key={selectedPatient} name="parentname" label={<span>Parent Patient Name</span>}>
                <Input
                  placeholder="Parent Patient"
                  className="h-10"
                  maxLength={10}
                  disabled={!selectedPatient && !isEditing}
                />
              </Form.Item>
              <button disabled={!isEditing} onClick={handlefamilyMemberModal} className="cursor-pointer disabled:cursor-not-allowed disabled:opacity-70">
                <FaSearch className="text-primaryColor text-lg" />
              </button>
            </div> */}
          </Form>
          <>
            <div className="flex items-center w-full justify-end my-5">
              {isEditing && (
                <>
                  <button
                    className="text-secondaryColor border-secondaryColor border rounded px-5 py-1.5 text-sm ml-3"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={onFinish}
                    disabled={loader}
                    className="bg-secondaryColor text-white border-brand-secondaryColor border rounded px-5 py-1.5 text-sm ml-3 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Save Changes
                  </button>
                </>
              )}
            </div>
          </>
        </div>

        {/* Mobile Number edit modal */}

        <Modal
          title={<h2 className="text-iconBlue">Validate mobile number</h2>}
          open={mobOtpModal}
          footer={[]}
          width={"30%"}
          onCancel={handleMobModalCancel}
          destroyOnClose
        >
          <MobNumVerification
            mobNum={updatingMob}
            PatientDetail={PatientDetail}
            handleModalClose={handleMobModalClose}
          />
        </Modal>

        {/* <div>
          {patientFamilyData.length > 0 &&
            patientFamilyData.map((user, index) => (
              <PatientForm
                key={user.id}
                user={user}
                salutation={salutation}
                gender={gender}
                bloodGroup={bloodGroup}
                marital={marital}
                Relation={Relation}
                stateData={stateData}
                patientData={patientFamilyData}
                handleFinish={(values) => handleFinish(values, index)}
                isEditing={isEditing[index]}
                setIsEditing={(value) => {
                  const newEditingState = [...isEditing];
                  newEditingState[index] = value;
                  setIsEditing(newEditingState);
                }}
              />
            ))}
        </div> */}
      </div>

      {/* {isModalOpen && (
        <Modal
          title="Add Family Member"
          visible={isModalOpen}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width="60%"
          maskClosable={false}
        >
          <AddFamilyMember onClose={() => handleCloseModal()} />
        </Modal>
      )} */}
    </Layout>
  );
};

export default MyProfile;
